export function nowIso() {
  return new Date().toISOString();
}

export function makeCreateMeta(userName = "", extra = {}) {
  const ts = nowIso();
  return {
    createdAt: ts,
    updatedAt: ts,
    updatedBy: userName || "",
    ...extra,
  };
}

export function makeUpdateMeta(userName = "", extra = {}) {
  return {
    updatedAt: nowIso(),
    updatedBy: userName || "",
    ...extra,
  };
}
